import React, { Component } from 'react';
import LongText from '../Utils/LongText';


class Intro extends Component {
    constructor(props) {
        super(props);
        this.state = {
        maxHeight: '40vh'
        };
    }

    handleMaxHeightChange = (newMaxHeight) => {
        this.setState({ maxHeight: newMaxHeight });
    };
  
render() {
    const { activeButton } = this.props;
    const { maxHeight } = this.state;
    return (
       <div style={{ all: 'unset' }}>
            {activeButton === 'about2' && (
                <div className="about-right-section-page">
                    <h1>Introduction</h1>
                <div className="about-right-section-text">
                <LongText maxLength={1} byParagraphs callBack={{call: this.handleMaxHeightChange,fullText:'40vh',truncatedText:'20vh'}}>
                    <p>Hi, welcome to my portfolio! I've designed this portfolio
                    to share what I'm passionate about, my background, education
                    and experience. Currently, I’m working towards a masters
                    degree in transpersonal psychology with a concentration in
                    creative expression. I’m fascinated with studying human
                    behavior, and how we can creatively design moral and ethical
                    systems that inspire real change in our world. 
                    </p>
                    <p>I’m also interested in studying how expressive arts
                    therapy can be used as a healing modality on an individual
                    level.This portfolio provides more insight into what I’m
                    researching and will give you a deeper understanding of my
                    work. In the navigation on this page, you will find brief
                    descriptions of each area. Feel free to read through them or
                    scroll on to the art below!
                    </p>
                    </LongText>
                </div>
                </div>
            )}
       </div> 
    );
  }
}

export default Intro;
